import { Directive, ElementRef, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { UserIdentityService } from '../authentication/user-identity.service';

@Directive({
  selector: '[mcbPermission]',
  exportAs: 'mcbPermission',
})
export class PermissionDirective {
  private viewCreated: boolean;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private userIdentityService: UserIdentityService
  ) {
  }

  @Input() set mcbPermission(permission: string) {
    const granted = this.userIdentityService.user.hasPermission(permission);
    if (granted && !this.viewCreated) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.viewCreated = true;
    } else if (!granted && this.viewCreated) {
      this.viewContainer.clear();
      this.viewCreated = false;
    }
  }
}
